module.exports = __webpack_public_path__ + "img/ybj.6a251dfd.png";